// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.invite-view {
  position: absolute;
  top: 0;
  left: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  background: #ffffff;
  font-family: Roboto, sans-serif;
  z-index: 10;
}

.invite-view__content {
  display: flex;
  flex-direction: column;
  align-items: center;
  max-width: 400px;
}

.invite-view__avatar-container {
  display: flex;
  justify-content: center;
  align-items: center;
}

.invite-view__avatar {
  width: var(--invite-view-avatar-size, 96px);
  height: var(--invite-view-avatar-size, 96px);
  border-radius: 50%;
  object-fit: cover;
}

.invite-view__avatar--placeholder {
  background: rgb(222, 72, 88);
  display: flex;
  justify-content: center;
  align-items: center;
  color: white;
  font-size: 48px;
}

.invite-view__message {
  font-size: 1.1rem;
  color: #1f2937;
  text-align: center;
  line-height: 1.6;
  font-weight: 600;
  padding: 0.25rem;
}

.invite-view__inviter-name {
  font-weight: 600;
  color: #1f2937;
}

.invite-view__room-id {
  font-size: 0.875rem;
  color: #8f97a6;
  text-align: center;
  padding-bottom: 2rem;
}

.invite-view__actions {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  width: 100%;
  align-items: center;
}

.invite-view__primary-actions {
  display: flex;
  gap: 0.75rem;
  width: 100%;
  justify-content: center;
}

.invite-view__button {
  padding: 0.875rem 1.75rem;
  border: none;
  border-radius: 8px;
  font-size: 1rem;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;
  max-width: 140px;
  font-family: Roboto, sans-serif;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.5);
}

.invite-view__button--decline {
  background: #979797;
  color: white;
}

.invite-view__button--decline:hover {
  background: #8d8d8d;
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);
}

.invite-view__button--accept {
  background: rgb(222, 72, 88);
  color: white;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.invite-view__button--accept:hover {
  background: rgb(200, 52, 68);
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);
}

.invite-view__button--block {
  background: transparent;
  color: rgb(222, 72, 88);
  border: none;
  font-size: 1.3rem;
  padding-top: 1.5rem;
  text-decoration: underline;
  text-decoration-thickness: 2px;
  font-weight: 600;
  max-width: none;
  box-shadow: none;
}

.invite-view__button--block:hover {
  color: #b91c1c;
  background: transparent;
}

`, "",{"version":3,"sources":["webpack://./src/components/Page/Conversations/ChatView/InviteView.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,+BAA+B;EAC/B,WAAW;AACb;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,2CAA2C;EAC3C,4CAA4C;EAC5C,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,4BAA4B;EAC5B,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,WAAW;EACX,uBAAuB;AACzB;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,gBAAgB;EAChB,+BAA+B;EAC/B,wCAAwC;AAC1C;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,2BAA2B;EAC3B,yCAAyC;AAC3C;;AAEA;EACE,4BAA4B;EAC5B,YAAY;EACZ,wCAAwC;AAC1C;;AAEA;EACE,4BAA4B;EAC5B,2BAA2B;EAC3B,yCAAyC;AAC3C;;AAEA;EACE,uBAAuB;EACvB,uBAAuB;EACvB,YAAY;EACZ,iBAAiB;EACjB,mBAAmB;EACnB,0BAA0B;EAC1B,8BAA8B;EAC9B,gBAAgB;EAChB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,uBAAuB;AACzB","sourcesContent":[".invite-view {\n  position: absolute;\n  top: 0;\n  left: 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 100%;\n  height: 100%;\n  background: #ffffff;\n  font-family: Roboto, sans-serif;\n  z-index: 10;\n}\n\n.invite-view__content {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  max-width: 400px;\n}\n\n.invite-view__avatar-container {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.invite-view__avatar {\n  width: var(--invite-view-avatar-size, 96px);\n  height: var(--invite-view-avatar-size, 96px);\n  border-radius: 50%;\n  object-fit: cover;\n}\n\n.invite-view__avatar--placeholder {\n  background: rgb(222, 72, 88);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  color: white;\n  font-size: 48px;\n}\n\n.invite-view__message {\n  font-size: 1.1rem;\n  color: #1f2937;\n  text-align: center;\n  line-height: 1.6;\n  font-weight: 600;\n  padding: 0.25rem;\n}\n\n.invite-view__inviter-name {\n  font-weight: 600;\n  color: #1f2937;\n}\n\n.invite-view__room-id {\n  font-size: 0.875rem;\n  color: #8f97a6;\n  text-align: center;\n  padding-bottom: 2rem;\n}\n\n.invite-view__actions {\n  display: flex;\n  flex-direction: column;\n  gap: 0.5rem;\n  width: 100%;\n  align-items: center;\n}\n\n.invite-view__primary-actions {\n  display: flex;\n  gap: 0.75rem;\n  width: 100%;\n  justify-content: center;\n}\n\n.invite-view__button {\n  padding: 0.875rem 1.75rem;\n  border: none;\n  border-radius: 8px;\n  font-size: 1rem;\n  font-weight: 500;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  max-width: 140px;\n  font-family: Roboto, sans-serif;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.5);\n}\n\n.invite-view__button--decline {\n  background: #979797;\n  color: white;\n}\n\n.invite-view__button--decline:hover {\n  background: #8d8d8d;\n  transform: translateY(-1px);\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);\n}\n\n.invite-view__button--accept {\n  background: rgb(222, 72, 88);\n  color: white;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n}\n\n.invite-view__button--accept:hover {\n  background: rgb(200, 52, 68);\n  transform: translateY(-1px);\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);\n}\n\n.invite-view__button--block {\n  background: transparent;\n  color: rgb(222, 72, 88);\n  border: none;\n  font-size: 1.3rem;\n  padding-top: 1.5rem;\n  text-decoration: underline;\n  text-decoration-thickness: 2px;\n  font-weight: 600;\n  max-width: none;\n  box-shadow: none;\n}\n\n.invite-view__button--block:hover {\n  color: #b91c1c;\n  background: transparent;\n}\n\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
